import { Box, Typography, Input } from '@mui/material'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import TextField from '@mui/material/TextField'
import React from 'react'
import { Formik } from 'formik'
import MaskedInput from 'react-text-mask/dist/reactTextMask'
import * as Yup from 'yup'
import MediaQuery from 'react-responsive'
import { useMixpanel } from '../../mixpanel-hook/mixpanel-context'
import * as S from './styles'
import Relaxation from '../../images/relaxation.svg'
import { integrate } from '../../services/RDstation'
import { IMaskInput } from 'react-imask';

const DialogSchema = Yup.object().shape({
	name: Yup.string().
		required('Preencha este campo.').
		min(3, 'O nome deve ter pelo menos 3 letras.'),
	phone: Yup.string().required('Preencha este campo.'),
	email: Yup.string().email('Email inválido.').required('Preencha este campo.'),
})

const TextMaskCustom = React.forwardRef(
    function TextMaskCustom(props, ref) {
        const { onChange, ...other } = props;
        return (
            <IMaskInput
                {...other}
                mask="(00) 00000-0000"
                definitions={{
                    '#': /[1-9]/,
                }}
                inputRef={ref}
                onAccept={(value) => onChange({ target: { name: props.name, value } })}
                overwrite
            />
        );
    },
)

export function ConversionDialog ({
	initialStep,
	open,
	handleCloseDialog,
	data,
	setHasConverted,
}) {
	const mixpanel = useMixpanel()
	return (
        <Formik
            validateOnBlur={false}
            validateOnChange={false}
            initialValues={{
                email: '',
                name: '',
                phone: '',
            }}
            validationSchema={DialogSchema}
            onSubmit={(values) => {
                mixpanel.track('Finalizou o planejador', {
                    email: values.email,
                    name: values.name,
                })
                mixpanel.people.set({
                    '$email': values.email,
                    '$name': values.name,
                })
                if (true) {
                    integrate(data, {
                        name: values.name,
                        email: values.email,
                        phone: values.phone,
                    }).
                        then((res) => {
                            setHasConverted(true)
                            return res
                        }).
                        then(() => handleCloseDialog()).
                        catch((e) => alert(
                            'Ocorreu um erro, por favor recarregue a página e tente novamente.'))
                } else {
                    setHasConverted(true)
                    handleCloseDialog()
                }
            }}>
            {({
                values,
                errors,
                handleChange,
                handleSubmit,
            }) => (<Dialog
                open={open}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogContent>

                    <S.Row>
                        <MediaQuery query="(min-width: 768px)">
                            <S.BoxImage>
                                <S.Image src={Relaxation} alt="Qual seu INSS?"
                                                 title="Qual seu INSS?"/>
                            </S.BoxImage>
                        </MediaQuery>
                        <div>
                            <DialogContentText>
                                <strong>Deseja receber o detalhamento do seu planejamento
                                    tributário?</strong>
                            </DialogContentText>
                            <br/>
                            <br/>

                            <TextField
                                fullWidth variant="filled"
                                id="name" name="name" type="text"
                                onChange={handleChange}
                                value={values.name} label="Qual seu nome?"
                                error={!!errors.name} helperText={errors.name || ' '}
                            />
                            <TextField
                                fullWidth variant="filled"
                                id="email" name="email" type="email"
                                onChange={handleChange}
                                value={values.email} label="Qual seu email?"
                                error={!!errors.email} helperText={errors.email || ' '}
                            />
                            <Input
                                fullWidth variant="filled"
                                id="phone" name="phone" type="phone"
                                onChange={handleChange}
                                inputComponent={TextMaskCustom}
                                value={values.phone} label="Qual seu telefone?"
                                error={!!errors.phone} helperText={errors.phone || ' '}
                            />
                            <Typography>
                                <Box style={{ marginTop: '12px' }}>
                                    Ao receber o resultado você está concordando com a nossa

                                    <Box style={{
                                        cursor: 'pointer',
                                        color: '#4e4ba6',
                                        display: 'inline',
                                    }}
                                             onClick={() => {
                                                 window.open(
                                                     'https://monefica.com.br/politica-de-privacidade/',
                                                     '_blank', 'noreferrer')
                                             }}
                                             component={'span'}>
                                        {' política de privacidade.'}
                                    </Box>
                                </Box>
                            </Typography>
                        </div>
                    </S.Row>

                </DialogContent>
                <DialogActions>
                    <Button disabled={!values.name || !values.email || !values.phone || values.phone.length < 15} onClick={() => {
                        if (window.mixpanel) {
                            window.mixpanel.track('INSS Dialog step 1 yes')
                        }
                        handleSubmit()
                    }} variant={'contained'} color="primary">
                        SIM
                    </Button>
                    <Button onClick={() => {
                        if (window.mixpanel) {
                            window.mixpanel.track('INSS Dialog step 1 close')
                        }
                        handleCloseDialog(true)
                    }} variant={'contained'} color="secondary">
                        VOLTAR
                    </Button>
                </DialogActions>
            </Dialog>)}
        </Formik>
    );
}
